// removed by extract-text-webpack-plugin
module.exports = {"Auth":"-name__-loca-__2YUr1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/Auth.css
// module id = 209
// module chunks = 0